
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar, ListChecks, Users } from "lucide-react";
import { cn } from "@/lib/utils";

const AgendaPreview = () => {
  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold font-display text-lawyer-primary mb-4">
            Gerencie sua Agenda Jurídica
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Organize seus compromissos, clientes e prazos processuais em um só lugar. 
            Otimize seu tempo e aumente sua produtividade com nossa agenda especializada para advogados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <FeatureCard 
            icon={<Users className="h-8 w-8 text-lawyer-secondary" />}
            title="Cadastro de Clientes"
            description="Mantenha todos os dados dos seus clientes organizados com campos específicos para a área jurídica, CPF/CNPJ validados e histórico completo de interações."
            href="/dashboard/clients"
          />
          
          <FeatureCard 
            icon={<Calendar className="h-8 w-8 text-lawyer-secondary" />}
            title="Agenda de Compromissos"
            description="Gerencie reuniões, audiências e prazos processuais com calendário integrado e lembretes personalizados."
            href="/dashboard/agenda"
          />
          
          <FeatureCard 
            icon={<ListChecks className="h-8 w-8 text-lawyer-secondary" />}
            title="Controle de Processos"
            description="Acompanhe o andamento dos seus processos, com datas importantes e notificações automáticas."
            href="/dashboard/appointments"
          />
        </div>

        <div className="text-center mt-12">
          <Button asChild size="lg" className="bg-lawyer-primary hover:bg-lawyer-primary/90">
            <Link to="/dashboard/agenda">
              Acessar Agenda
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  href: string;
}

const FeatureCard = ({ icon, title, description, href }: FeatureCardProps) => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg shadow-md p-6 flex flex-col hover:shadow-lg transition-shadow">
      <div className="mb-4">{icon}</div>
      <h3 className="text-xl font-bold mb-2 text-lawyer-primary">{title}</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-4 flex-grow">{description}</p>
      <Button asChild variant="outline" className="mt-auto">
        <Link to={href}>Saiba mais</Link>
      </Button>
    </div>
  );
};

export default AgendaPreview;
